export default defineNuxtPlugin({
  name: 'cart-load',
  dependsOn: ['services'],
  async setup() {
    // The B2B cart belongs to the signed-in customer — there is no anonymous cart
    // and no cart-hash cookie — so this only has something to load once a token
    // exists. `fetchCart()` is a no-op while signed out; the login flow refreshes
    // the customer store, and the watcher below picks the cart up from there.
    const cartStore = useB2BCartStore()
    const customerStore = useCustomerStore()

    // Loaded on the server too, so the header count and the in-cart marker on a
    // catalogue row are in the first HTML rather than appearing after hydration.
    // The fetch must not be able to take an SSR render down: the cart is not what
    // the page is about, and a page that 500s because the cart endpoint hiccuped
    // is a worse outcome than one that renders with an empty badge.
    //
    // The plugin is universal, so on the client it runs again during hydration.
    // The store already holds the cart the server just loaded (Pinia state is
    // serialised into the payload), and fetching it a second time rebuilt the
    // whole cart server-side on every full page load for nothing. Only a cart the
    // server did not manage to load is fetched again here.
    try {
      if (import.meta.server || !cartStore.cart) await cartStore.fetchCart()
    }
    catch (error) {
      console.error('[cart] initial load failed', error)
    }

    watch(() => customerStore.isLoggedIn, (loggedIn) => {
      if (loggedIn) {
        cartStore.fetchCart()
        return
      }
      cartStore.reset()
      // The manager toolbar's state belongs to the session that built it: a ticked
      // selection and another customer's saved filter presets must not survive into
      // the next login in the same tab.
      useCatalogSelection().clear()
      useSavedCatalogFilters().reset()
    })
  },
})
